export default __webpack_public_path__ + "static/media/image.6c688694.png";